// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import component_0 from "./AddPhone";
import component_1 from "./SettingsHeader";
import component_2 from "./UserPhoneCard";
export const AddPhone = component_0;
export const SettingsHeader = component_1;
export const UserPhoneCard = component_2;
